export function moneyFormat(value: number, fractionDigits: number = 0) {
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: fractionDigits
  })
  return formatter.format(value)
}

export function numberFormat(value: number, fractionDigits: number = 0) {
  const formatter = new Intl.NumberFormat('de-DE', {
    maximumFractionDigits: fractionDigits
  })
  return formatter.format(value)
}
